module.exports = "img,\ndiv {\n  height: 100%;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\ndiv {\n  background-clip: content-box;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  -webkit-backface-visibility: hidden;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/user-picture/user-picture.component.less
// module id = 576
// module chunks = 0